// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import HomePage from "./pages/home";
import RealFakePage from "./pages/quiz/RealFakePage";
import ScenarioPage from "./pages/quiz/ScenarioPage";
import BackgroundInfo from "./pages/info/BackgroundInfo";
import InfoFromBackground from "./pages/info/InfoFromBackground";
import BackgroundInfoDetail from "./pages/info/BackgroundInfoDetail";
import ClaimPage from "./pages/ClaimPage";
import MatchPage from "./pages/MatchPage";
import PolicySwipe from "./pages/PolicySwipe";
import PoliticalMatchIntro from "./pages/PoliticalMatchIntro";
import PolicyAreaSelection from "./pages/PolicyAreaSelection";
import MPProfile from "./pages/MPProfile";
import TrendingTopics from "./pages/TrendingTopics";
import Navbar from "./components/Navbar";
import ChallengePage from "./pages/quiz/ChallengePage";
import ScrollToTop from "./components/ScrollToTop";
import PolicyTracker from "./pages/policy_tracker/PolicyTracker";
import MPOverview from "./pages/MPOverview";

// import PasswordPage from "./pages/login/PasswordPage";
// import ProtectedRoute from "./components/login/ProtectedRoute";
import VoterInsightsPage from "./pages/VoterInsightsPage";
import NewHomePage from "./pages/Home/NewHomePage";
import Footer from "./components/Footer";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/password" element={<PasswordPage />} /> */}

        <Route
          path="/*"
          element={
            // <ProtectedRoute>
            <>
              <Navbar />
              <ScrollToTop /> {/* Handle Scroll here (Always start from top) */}
              <div style={{ paddingTop: "70px" }}></div>
              <Routes>
                <Route path="/" element={<NewHomePage />} />
                <Route path="/ask" element={<ClaimPage />} />
                <Route path="/ask/:searchId" element={<ClaimPage />} />

                <Route path="/challenge" element={<ChallengePage />} />
                <Route path="/info" element={<BackgroundInfo />} />
                <Route path="/topics" element={<TrendingTopics />} />
                <Route path="/quiz" element={<RealFakePage />} />
                <Route path="/scenario" element={<ScenarioPage />} />
                <Route path="/backgroundinfo" element={<BackgroundInfo />} />
                <Route path="/policy-tracker" element={<PolicyTracker />} />
                <Route
                  path="/inforfrombackground"
                  element={<InfoFromBackground />}
                />
                <Route path="/policy-swipe" element={<PoliticalMatchIntro />} />
                <Route path="/policy-areas" element={<PolicyAreaSelection />} />
                <Route path="/voter-insight" element={<VoterInsightsPage />} />
                <Route path="/policy-swipe/swipe" element={<PolicySwipe />} />
                <Route path="/policy-swipe/matches" element={<MatchPage />} />
                <Route path="/mp/:encodedMpID" element={<MPProfile />} />

                <Route path="/new-home" element={<NewHomePage />} />

                <Route path="/info-detial" element={<BackgroundInfoDetail />} />
                <Route path="/mp-overview/:id" element={<MPOverview />} />
              </Routes>
              <Footer />
            </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
